import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import TableToolbox from '../../../components/TableToolbox';
import NewAnnouncement from '../NewAnnouncement';
import {
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import EnhancedTableHead from '../../../components/DataTables/TableHead';
import {
  applySortFilter,
  getComparator,
  getErrorMessage,
  tableCell,
} from '../../../utils/appUtils';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { fetchAnnouncementList } from '../../../redux/actions/adminActions/announcementList';
import { Strings } from '../../../utils/strings';
import moment from 'moment';
import { useAlert } from 'react-alert';

// ======== Table Head =========
const headCells = [
  { id: 'title', label: 'TITLE', isSort: true },
  { id: 'visibleTo', label: 'VISIBLE TO', isSort: true },
  { id: 'startDate', label: 'START ON', isSort: true },
  { id: 'endDate', label: 'END ON', isSort: true },
  { id: 'status', label: 'STATUS' },
];

const AnnouncementList = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const alert = useAlert();
  const [search, setSearch] = useState('');
  const [newDialog, setNewDialog] = useState(false);
  const [announcementList, setAnnouncementList] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  useEffect(() => {
    props.fetchAnnouncementList(search, '', (err) => onError(err));
  }, [props.addAnnouncementData, search]);

  useEffect(() => {
    const data = props.announcementListData ? props.announcementListData : [];
    setAnnouncementList(data);
  }, [props.announcementListData]);

  const descendingComparator = (a, b, orderBy) => {
    let asceding = b[orderBy] < a[orderBy];
    let descding = b[orderBy] > a[orderBy];
    if (orderBy === 'title') {
      asceding = b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase();
      descding = b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase();
    } else if (orderBy === 'visibleTo') {
      asceding = b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase();
      descding = b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase();
    } else if (orderBy === 'startDate' || orderBy === 'endDate') {
      asceding = moment(b[orderBy]) < moment(a[orderBy]);
      descding = moment(b[orderBy]) > moment(a[orderBy]);
    }
    if (asceding) return -1;
    if (descding) return 1;
    return 0;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const filteredAnnouncements = applySortFilter(
    announcementList,
    getComparator(order, orderBy, descendingComparator)
  );

  return (
    <div className={classes.announcement_container}>
      <TableToolbox
        isSearch
        isPrimaryButton
        search={search}
        onChangeSearch={(e) => setSearch(e.target.value)}
        onNewClick={() => setNewDialog(true)}
      />
      <div className={classes.list_container}>
        {props.announcementListLoading ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : (
          <>
            {announcementList.length === 0 ? (
              <div className={classes.flexView}>
                <p className={classes.no_data_message}>
                  {Strings.NO_DATA_FOUND}
                </p>
              </div>
            ) : (
              <TableContainer>
                <Table sx={{ minWidth: 930 }} aria-labelledby='tableTitle'>
                  <EnhancedTableHead
                    headCells={headCells}
                    handleRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  <TableBody>
                    {announcementList.length > 0 &&
                      filteredAnnouncements?.map((data) => {
                        const { title, visibleTo, startDate, endDate } = data;
                        return (
                          <TableRow key={data._id} sx={{ width: '100%' }}>
                            <TableCell
                              style={{ ...tableCell(theme) }}
                              component='td'
                              scope='row'
                            >
                              <Stack
                                paddingTop={2.5}
                                direction='column'
                                alignItems='flex-start'
                              >
                                <label className={classes.common_cell}>
                                  {title}
                                </label>
                              </Stack>
                            </TableCell>
                            <TableCell
                              style={{ ...tableCell(theme) }}
                              component='td'
                              scope='row'
                            >
                              <Stack
                                paddingTop={2.5}
                                direction='column'
                                alignItems='flex-start'
                              >
                                <label className={classes.common_cell}>
                                  {`All ${visibleTo}`}
                                </label>
                              </Stack>
                            </TableCell>
                            <TableCell
                              style={{ ...tableCell(theme) }}
                              component='td'
                              scope='row'
                            >
                              <Stack
                                paddingTop={2.5}
                                direction='column'
                                alignItems='flex-start'
                              >
                                <label className={classes.common_cell}>
                                  {`${moment(startDate).format(
                                    'MMM DD, YYYY'
                                  )} at ${moment(startDate).format('hh a')}`}
                                </label>
                              </Stack>
                            </TableCell>
                            <TableCell
                              style={{ ...tableCell(theme) }}
                              component='td'
                              scope='row'
                            >
                              <Stack
                                paddingTop={2.5}
                                direction='column'
                                alignItems='flex-start'
                              >
                                <label className={classes.common_cell}>
                                  {`${moment(endDate).format(
                                    'MMM DD, YYYY'
                                  )} at ${moment(endDate).format('hh a')}`}
                                </label>
                              </Stack>
                            </TableCell>
                            <TableCell
                              style={{ ...tableCell(theme) }}
                              component='td'
                              scope='row'
                            >
                              <Stack
                                paddingTop={2.5}
                                direction='column'
                                alignItems='flex-start'
                              >
                                <label
                                  className={classNames(
                                    classes.common_cell,
                                    classes.status_container
                                  )}
                                >
                                  {moment(new Date()) > moment(endDate)
                                    ? 'In Active'
                                    : 'Active'}
                                </label>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </div>
      {newDialog && <NewAnnouncement onNewClose={() => setNewDialog(false)} />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  addAnnouncementData: state.addAnnouncementData.data,
  announcementListData: state.announcementListData.data,
  announcementListLoading: state.announcementListData.loading,
});

export default connect(mapStateToProps, {
  fetchAnnouncementList,
})(AnnouncementList);
